import React, {Component, useLayoutEffect} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import jwt_decode from "jwt-decode";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import * as moment from "moment";
import DatePicker from "react-datepicker";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
var yesterday = new Date(Date.now() + 0 * 40 * 60 * 1000);

var yestSend = moment(yesterday).format('YYYY-MM-DD');

class DisputeOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            requestDate:yestSend,
            paymentDate:yestSend,
            loading:false,
            OrderId:'',
            ActualQTY:'',
            ReceiveQTY:'',
            LossQTY:'',
            imageData:'',
            productLis:[],
            Amount:''

        }
    }

    componentDidMount() {

        axios.get(config.get('API_URL') + '/inventory/getProductList', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`,
                SalesforceToken: ` ${localStorage.salesforce_token}`
            }
        }).then(response => {
            this.setState({
                productLis: response.data
            })
            console.log(this.state.productLis);
        })
            .catch(err=>{
                console.log(err);
            })




        const token = localStorage.usertoken;
        try {
            const decoded = jwt_decode(token);

            console.log(decoded.userGroupName);
            // this.setState({
            //     userName: decoded.firstName + ' ' + decoded.lastName,
            //     user_type: decoded.userGroupName,
            // });

        } catch (err) {
            console.log("expired check failed!");
        }

    }

    OnProductChangeChange(e) {

        if (e.target.value === "Select...") {
            return false;
        }

        var index = e.target.selectedIndex;
        var txt = e.target[index].text;
        var val =e.target[index].value;

        this.setState({
            OrderId:val
        })

    }

    OnQuantityChange(e){
        var qty= e.target.value;
        if (isNaN(qty)) {
            return;
        }
        else{
            if(qty>0) {
                this.setState({
                    ReceiveQTY: qty
                })
            }
            else
            {
                this.setState({
                    ReceiveQTY: ''
                })
            }
        }
    }

    onLossChange(e){

        var LossQTY= e.target.value;
        if (isNaN(LossQTY)) {
            return;
        }
        else{

            this.setState({
                LossQTY: LossQTY
            })
        }
    }

    handleFromChange = date => { //alert(date);
        var date_filter = moment(date).format('YYYY-MM-DD');
        this.setState({
            paymentDate: date_filter
        });
    };

    _onChange(){



    }



    async onPlaceOrderClick(){



        if(this.state.OrderId ==='' || this.state.OrderId ==='Select...')
        {
            this.props.handleClick("tr", 3, "Select Order Id.");
            return;
        }

        if(this.state.ReceiveQTY <=0){
            this.props.handleClick("tr", 3, "Enter Quantity");
            return;
        }

        if(this.state.LossQTY ===''){
            this.props.handleClick("tr", 3, "Enter Amount");
            return;
        }

        var imagedata = document.getElementById('imgView').src;

        document.getElementById("OrderPlacementSubmit").disabled = true;

        const token = localStorage.usertoken;
        let warehouse_id = '';
        if (token != null) {
            const decoded = jwt_decode(token);
            warehouse_id = decoded.warehouse_id
        }

        var tempData={
            Distributor__c:warehouse_id,
            Request_date__c: this.state.paymentDate,
            Payment_Amount__c: this.state.LossQTY,
            Payment_Date__c:  this.state.paymentDate,
            Payment_Details__c: '',
            Product_Name__c: this.state.OrderId,
            Quantity__c: this.state.ReceiveQTY,
        }

        var chMsg=';'
        await axios.post(config.get('API_URL') + '/inventoryLoss/OrderPlacementForm',tempData, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`,
                SalesforceToken: ` ${localStorage.salesforce_token}`
            },
        }).then(response => {
            if(response.data==="Success")
            {
                chMsg="Success";
                this.props.handleClick("tr", 1, "Record has been saved successfully.");
            }
        })
            .catch((err)=>{
                console.log('Error');
                console.log(err);
            });

        if(chMsg==='Success') {
            setTimeout(function () {
                window.location.href = "/admin/orders";
            }.bind(this), 3000);

        }
    }

    render() {

        let bindProductList= this.state.productLis.map((data)=>{
            return(
                <option value={data.Id}>{data.Description__c}</option>
            )
        })


        return (
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style}/>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div>
                                <div className="col-mid-12 no-padd">
                                    <div className="card title-card-bottom-space">
                                        <div className="header">
                                            <h4 className="title">Dispute Form</h4>
                                            <p className="category"></p>
                                        </div>
                                    </div>
                                </div>

                                <div className="clearfix"></div>
                                <React.Fragment>
                                    <div className=" content bgcolor">
                                        <div className=" container-fluid ">

                                            <div className="p-10">

                                                <div className="">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="col-md-8">
                                                                <div className="col-md-3">
                                                                    <label> Order Id:</label>
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <select id="OrderId" name="ProductName" className="form-control"
                                                                            onChange={(e) => this.OnProductChangeChange(e)}>
                                                                        <option value="Select...">Select...</option>
                                                                        {bindProductList}
                                                                    </select>
                                                                </div>
                                                                <div className="clearfix"></div>
                                                                <div className="gap_ver"></div>
                                                                <div className="col-md-3">
                                                                    <label> Actual Order Quantity: </label>
                                                                </div>

                                                                <div className="col-md-5">
                                                                    <input name="ActualQTY" className="form-control"  value={this.state.ActualQTY} />
                                                                </div>
                                                                <div className="clearfix"></div>
                                                                <div className="gap_ver"></div>
                                                                <div className="col-md-3">
                                                                    <label> Received Order Quantity: </label>
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <input name="ReceivedQTY" className="form-control"  value={this.state.ReceiveQTY} onChange={this.OnQuantityChange.bind(this)} />
                                                                </div>
                                                                <div className="clearfix"></div>
                                                                <div className="gap_ver"></div>
                                                                <div className="col-md-3">
                                                                    <label>Loss Quantity:</label>
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <input name="LossQTY" className="form-control " value={this.state.LossQTY} onChange={this.onLossChange.bind(this)} />
                                                                </div>
                                                                <div className="clearfix"></div>
                                                                <div className="gap_ver"></div>

                                                                <div className="col-md-3">
                                                                    <label>Comment:</label>
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <textarea id="comment" name="comment" className="form-control" rows="4" cols="50" onChange={this._onChange.bind(this)}>
  </textarea>

                                                                </div>
                                                                <div className="clearfix"></div>
                                                                <div className="gap_ver"></div>
                                                                <div className="col-md-12 invetoryTextCenter">
                                                                    <hr />
                                                                    <button type="button" id="OrderPlacementSubmit" className="btn btn-primary"  onClick={this.onPlaceOrderClick.bind(this)} >Submit
                                                                    </button>
                                                                    {' '}

                                                                    {/*<button type="button" className="btn btn-secondary"  >Cancel </button>*/}
                                                                    {/*onClick={this.onDisSubmit.bind(this)}*/}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4 " >

                                                            </div>
                                                        </div>
                                                        <div className="">

                                                            <div className="clearfix"></div>
                                                            <div className="gap_ver"></div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </React.Fragment>

                                <div className="footer">
                                    <div className="stats"><i></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DisputeOrder;